import IsPregnant from '../../components/master/healthProfile/steps/IsPregnant';
import IsSmoke from '../../components/master/healthProfile/steps/IsSmoke';
import IsDiabetic from '../../components/master/healthProfile/steps/IsDiabetic';
import IsHighBP from '../../components/master/healthProfile/steps/IsHighBP';
import TakingHighBpMedication from '../../components/master/healthProfile/steps/TakingHighBpMedication';
import Ethnicity from '../../components/master/healthProfile/steps/Ethinicty';
import HasStroke from '../../components/master/healthProfile/steps/HasStroke';
import HeartAttack from '../../components/master/healthProfile/steps/HeartAttack';
import wellnessGoals from '../../components/master/healthProfile/steps/WellnessGoals';
import MedicalCondition from '../../components/master/healthProfile/steps/MedicalCondition';
import Allergies from '../../components/master/healthProfile/steps/Allergies';
import SupplementsDetails from '../../components/master/healthProfile/steps/SupplemetsDetails';
import TakingSupplements from '../../components/master/healthProfile/steps/TakingSupplements';
import TermCondition from '../../components/master/healthProfile/steps/TermCondition';
import MenopausalStatus from '../../components/master/healthProfile/steps/IsMenopause';

const healthProfileConfig = [
  IsPregnant,
  MenopausalStatus,
  IsSmoke,
  IsDiabetic,
  Ethnicity,
  IsHighBP,
  TakingHighBpMedication,
  HeartAttack,
  HasStroke,
  wellnessGoals,
  MedicalCondition,
  Allergies,
  TakingSupplements,
  SupplementsDetails,
  TermCondition,
];

export default healthProfileConfig;
